import { arrayToObject } from '@hotglue/common';

const defaultState = {
  lastJob: {},
  polling: {},
  activeJobTypes: {}, // Track active job type per entity: { "tenant/flow/entityId": "read|write|fullSync" }
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SET_TENANT':
      // Only clear job state if tenant actually changed
      // This preserves running jobs when widget is reopened with same tenant
      const currentTenant = Object.keys(newState.lastJob).length > 0 ? 
        Object.keys(newState.lastJob)[0].split('/')[0] : null;
      
      if (currentTenant !== String(payload)) {
        newState.lastJob = {};
        newState.activeJobTypes = {};
      }
      return newState;
    case 'FETCH_LAST_JOB':
      if (status == 'success' && payload && payload.flow_id && params?.entityId){
        newState.lastJob[`${payload.tenant}/${payload.flow_id}/${params.entityId}`] = payload;
      }

      if (status == 'success' && payload && payload.flow_id) {
        newState.lastJob[`${payload.tenant}/${payload.flow_id}`] = payload;
      }

      return newState;
    case 'SET_POLLING_JOB': {
      const { flow, jobRoot, tenant } = params;
      newState.polling = {
        ...newState.polling,
        [`${flow}/${tenant}`]: {
          ...newState.polling[`${flow}/${tenant}`],
          [jobRoot]: payload,
        },
      };

      return newState;
    }
    case 'SET_ACTIVE_JOB_TYPE': {
      const { tenant, flowId, entityId, jobType } = params;
      const entityKey = `${tenant}/${flowId}/${entityId}`;
      newState.activeJobTypes = {
        ...newState.activeJobTypes,
        [entityKey]: jobType,
      };
      return newState;
    }
    case 'CLEAR_ACTIVE_JOB_TYPE': {
      const { tenant, flowId, entityId } = params;
      const entityKey = `${tenant}/${flowId}/${entityId}`;
      newState.activeJobTypes = { ...newState.activeJobTypes };
      delete newState.activeJobTypes[entityKey];
      return newState;
    }
  }

  return state;
};
